var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { Collection } from 'hanako-ts/dist-legacy/Collection';
import { LazyLoader } from '../../../ts/components/LazyLoader';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', false);
        this.lastScrollTop = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('body').on('click', '#project-list a', (event, link) => __awaiter(this, void 0, void 0, function* () {
                event.preventDefault();
                $('#menu-mask').addClass('is-open');
                $('.spinner').removeClass('d-none');
                /*const response = await $.httpRequest({
                  url: '/wp-admin/admin-ajax.php',
                  type: 'POST',
                  body: {
                    action: 'get_project',
                    id: link.data('id')
                  },
                  dataType: 'html'
                });*/
                const response = yield $.httpRequest({
                    url: link.attr('href'),
                    type: 'GET',
                    dataType: 'html'
                });
                // Extract project content from response
                let projectContent = new Collection();
                response.forEach((element) => {
                    if ($(element).attr('id') === 'project-content')
                        projectContent = $(element);
                });
                $('#project-container').empty().append(projectContent).addClass('is-open');
                $('#project-container').get(0).scrollTo(0, 0);
                $('#menu-mask').removeClass('is-open');
                $('.spinner').addClass('d-none');
                LazyLoader.refreshImageList();
                LazyLoader.checkImageVisibility();
                $('.header-default').removeClass('justify-content-end').addClass('justify-content-between');
                $('.header-default .btn-info').removeClass('d-none');
                this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
                $('body').addClass('position-fixed');
            }));
            if ($('body').hasClass('home')) {
                $('body').on('click', '#project-container .btn-back', (event, button) => {
                    event.preventDefault();
                    $('#project-container').removeClass('is-open').empty();
                    $('.header-default').addClass('justify-content-end').removeClass('justify-content-between');
                    $('.header-default .btn-info').addClass('d-none');
                    $('body').removeClass('position-fixed');
                    window.scrollTo(0, this.lastScrollTop);
                });
            }
            this.success();
        });
    }
}
